import React from 'react';
import { brandGradients, brandTextGradients } from '../theme/palette';

const About = () => {
  return (
    <section id="about" className="py-20 lg:py-16 bg-gradient-to-br from-gray-50 to-blue-50">
  <div className="container">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-20 items-center">
          {/* Left Content */}
          <div className="animate-on-scroll">
            <div className="space-y-8">
              <div>
                <span className="text-[#00a4f4] text-xl font-bold" style={{ color: '#ff70a6' }}>
                  About RLDS Pvt Ltd
                </span>
                <h2 className="text-4xl lg:text-6xl font-black text-gray-800 mt-4 leading-tight">
                  Professional
                  <span className="block text-blue-600">Due Diligence Services</span>
                  Since 2019
                </h2>
              </div>

              <div className="space-y-6">
                <p className="text-xl text-gray-600 leading-relaxed">
                  <strong>RAGHUVEER REDDY LINGAMPALI DETECTIVE SERVICES PRIVATE Ltd (RLDS Pvt Ltd)</strong> is 
                  headquartered in Kurnool, Andhra Pradesh with branches across major cities in 
                  Andhra Pradesh, Telangana, Karnataka & Tamil Nadu.
                </p>

                <p className="text-lg text-gray-600 leading-relaxed">
                  We have a team of highly skilled professionals including <strong>Chartered Accountants, 
                  Lawyers, and Retired Police Professionals</strong> with proven experience in providing 
                  quality verification services across South India.
                </p>

                <div className="bg-white p-6 rounded-2xl shadow-1xl border-l-4 border-blue-600">
                  <p className="text-lg text-gray-700 italic">
                    "We provide timely and accurate reports to meet the needs of each individual client. 
                    We proactively work with our clients, understand their business needs and uphold their business standards."
                  </p>
                </div>
              </div>

              
            </div>
          </div>

          {/* Right Image */}
          <div className="animate-on-scroll">
            <div className="relative">
              <div className="relative group">
                <img 
                  src="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
                  alt="Professional investigation team" 
                  className="rounded-3xl shadow-1xl w-full h-auto group-hover:shadow-blue-500/25 transition-all duration-500"
                />

                {/* Overlay Stats */}
                <div className="absolute -bottom-8 -right-8 text-white p-6 rounded-2xl shadow-1xl" style={{ background: brandGradients.panel }}>
                  <div className="text-center">
                    <div className="text-4xl font-bold">4</div>
                    <div className="text-sm opacity-90">States Coverage</div>
                    <div className="text-xs opacity-75 mt-1">AP, TS, KA, TN</div>
                  </div>
                </div>

                <div className="absolute -top-6 -left-6 bg-white p-4 rounded-2xl shadow-1xl">
                  <div className="flex items-center space-x-2">
                    <div className="w-3 h-3 bg-green-400 rounded-full animate-pulse"></div>
                    <span className="text-sm font-semibold text-gray-700">Active Since 2019</span>
                  </div>
                </div>
              </div>

              {/* Background decoration */}
              <div className="absolute -inset-4 bg-gradient-to-r from-blue-200/50 to-purple-200/50 rounded-3xl -z-10 blur-xl"></div>
            </div>
          </div>
        </div>

        {/* Key Highlights - full width row */}
        <div className="mt-12 animate-on-scroll">
          <div className="grid md:grid-cols-4 gap-6">
            <div className="flex items-center space-x-4 p-4 bg-white rounded-xl shadow-1xl">
              <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center">
                <i className="fas fa-map-marker-alt text-blue-600 text-xl"></i>
              </div>
              <div>
                <h4 className="font-bold text-gray-800">Headquartered</h4>
                <p className="text-gray-600 text-sm">Kurnool, Andhra Pradesh</p>
              </div>
            </div>

            <div className="flex items-center space-x-4 p-4 bg-white rounded-xl shadow-1xl">
              <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center">
                <i className="fas fa-users text-green-600 text-xl"></i>
              </div>
              <div>
                <h4 className="font-bold text-gray-800">Expert Team</h4>
                <p className="text-gray-600 text-sm">CAs, Lawyers, Ex-Police</p>
              </div>
            </div>

            <div className="flex items-center space-x-4 p-4 bg-white rounded-xl shadow-1xl">
              <div className="w-12 h-12 bg-purple-100 rounded-xl flex items-center justify-center">
                <i className="fas fa-shield-alt text-purple-600 text-xl"></i>
              </div>
              <div>
                <h4 className="font-bold text-gray-800">Confidentiality</h4>
                <p className="text-gray-600 text-sm">High Degree Security</p>
              </div>
            </div>

            <div className="flex items-center space-x-4 p-4 bg-white rounded-xl shadow-1xl">
              <div className="w-12 h-12 bg-orange-100 rounded-xl flex items-center justify-center">
                <i className="fas fa-clock text-orange-600 text-xl"></i>
              </div>
              <div>
                <h4 className="font-bold text-gray-800">Timely Reports</h4>
                <p className="text-gray-600 text-sm">Within Time Bond</p>
              </div>
            </div>
          </div>
        </div>

        {/* Coverage Areas */}
        <div className="mt-20 animate-on-scroll">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-gray-800 mb-4">Our Coverage Areas</h3>
            <p className="text-lg text-gray-600">Serving major cities across South India</p>
          </div>

          <div className="grid md:grid-cols-4 gap-8">
            <div className="text-center p-6 bg-white rounded-2xl shadow-1xl hover:shadow-1xl transition-all duration-300">
              <div className="w-16 h-16 bg-gradient-to-r from-red-500 to-red-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="fas fa-map-marker-alt text-white text-xl"></i>
              </div>
              <h4 className="font-bold text-gray-800 text-lg mb-2">Andhra Pradesh</h4>
              <p className="text-gray-600 text-sm">Kurnool, Tirupati, Vijayawada, Visakhapatnam, Guntur, Nellore & more</p>
            </div>

            <div className="text-center p-6 bg-white rounded-2xl shadow-1xl hover:shadow-1xl transition-all duration-300">
              <div className="w-16 h-16 bg-gradient-to-r from-pink-500 to-pink-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="fas fa-map-marker-alt text-white text-xl"></i>
              </div>
              <h4 className="font-bold text-gray-800 text-lg mb-2">Telangana</h4>
              <p className="text-gray-600 text-sm">Hyderabad, Warangal, Karimnagar, Mahbubnagar & more</p>
            </div>

            <div className="text-center p-6 bg-white rounded-2xl shadow-1xl hover:shadow-1xl transition-all duration-300">
              <div className="w-16 h-16 bg-gradient-to-r from-yellow-500 to-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="fas fa-map-marker-alt text-white text-xl"></i>
              </div>
              <h4 className="font-bold text-gray-800 text-lg mb-2">Karnataka</h4>
              <p className="text-gray-600 text-sm">Bangalore and other major cities</p>
            </div>

            <div className="text-center p-6 bg-white rounded-2xl shadow-1xl hover:shadow-1xl transition-all duration-300">
              <div className="w-16 h-16 bg-gradient-to-r from-green-500 to-teal-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="fas fa-map-marker-alt text-white text-xl"></i>
              </div>
              <h4 className="font-bold text-gray-800 text-lg mb-2">Tamil Nadu</h4>
              <p className="text-gray-600 text-sm">Chennai and other key locations</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;